import "foundation-sites";

let	copyButtons	= document.querySelectorAll("[data-clipboard-text]");

copyButtons.forEach(btn => {
	btn.addEventListener('click', () => {
		navigator.clipboard.writeText(btn.dataset.clipboardText);
		let message = btn.querySelector('.success');
		$(message).fadeIn(200);
		setTimeout(function() {
			$(message).fadeOut(2000);
		}, 2000);
	});
});

// Require at least 'data-validator-min' checkboxes to be checked
// http://foundation.zurb.com/forum/posts/37486-foundation-61-abide-checkbox-radio-buttons
function checkboxLimit ($el, required, parent)
{
	var group = parent.closest('.jsCheckboxGroup');
	var min = group.attr('data-validator-min');
	var checked = group.find(':checked').length;
	if (checked >= min)
	{
		// clear label highlight
		group.find('label').each(function()
		{
			$(this).removeClass('is-invalid-label');
		});
		// clear checkbox error
		group.find(':checkbox').each(function()
		{
			$(this).removeClass('is-invalid-input').removeAttr('data-invalid');
		});
		group.find('.form-error').hide();
		return true;
	}
	else
	{
		group.find('.form-error').css(
		{
			display: 'block'
		});
		return false;
	}
};

Foundation.Abide.defaults.validators['checkbox_limit'] = checkboxLimit;

$(document).foundation();

$(document).ready(function()
{

	// Print
	if(location.hash == '#print')
	{
		window.print();
	}

	$('.print').on('click', function()
	{
		window.print();
	});

	if (!Foundation.MediaQuery.atLeast('medium'))
	{
		$('.table-of-contents .sticky').foundation('_destroy');
	}
});